import type { Translations } from './types';

export const en: Translations = {
  // Common
  common: {
    backToHome: '← Back to Home',
    back: '← Back',
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    start: 'Start!',
    pause: 'Pause',
    resume: 'Resume',
    menu: 'Menu',
    score: 'Score',
    rank: 'Rank',
    of: 'of',
    name: 'Name',
    email: 'E-Mail',
    optional: 'optional',
    saving: 'Saving...',
    scoreSaved: 'Score saved!',
    goodLuck: 'Good luck!',
    noScores: 'No scores yet',
    highscores: 'Highscores',
  },

  // Navigation
  nav: {
    home: 'Home',
    leaderboard: 'Leaderboard',
  },

  // Home page
  home: {
    hero: 'Industrial Games',
    heroHighlight: ' Platform',
    heroSubtitle: 'Learn about industrial automation while having fun. Compete for the top spot on the leaderboard!',
    viewLeaderboard: '🏆 View Leaderboard',
    chooseGame: 'Choose Your Game',
    topPlayers: '🏆 Top Players',
    viewAll: 'View All →',
    howItWorks: 'How It Works',
    step1Title: 'Pick a Game',
    step1Desc: 'Choose from our collection of industrial automation themed mini-games.',
    step2Title: 'Play & Score',
    step2Desc: 'Complete challenges, earn points, and climb the leaderboard.',
    step3Title: 'Win Prizes',
    step3Desc: 'Top daily scores can win exciting prizes. Enter your email to participate!',
    poweredBy: 'Powered by UKONNX',
    cabinetTitle: 'Cabinet Transformer',
    cabinetSubtitle: 'Whack the Cabinets!',
    cabinetDesc: 'Transform old-school control cabinets into modern decentralized solutions. Click fast, score high!',
    automationTitle: 'Automation Drop',
    automationSubtitle: 'Drag & Drop Challenge',
    automationDesc: 'Drag automation parts to the correct slots. Build the perfect industrial system!',
    playNow: 'Play Now',
  },

  // Leaderboard
  leaderboard: {
    title: 'Leaderboard',
    subtitle: 'Top players across all UKONNX games',
    allGames: 'All Games',
    player: 'Player',
    game: 'Game',
    date: 'Date',
    noScoresYet: 'No scores yet. Be the first to play!',
    previous: '← Previous',
    next: 'Next →',
    page: 'Page',
  },

  // Cabinet Transformer Game
  cabinetTransformer: {
    title: 'CABINET Hunter',
    subtitle: '— POWERED BY UKONNX —',
    missionTitle: 'Mission: Zero Cabinet!',
    missionText: 'Turn Cabinets into Decentral Solutions!',
    howToPlay: 'HOW TO PLAY:',
    inst1: 'Tag Cabinets to score Points',
    inst2: '10 missed Cabinets = Game Over',
    inst3: 'Tag the uKonn-X Logo for bonus-points',
    howToWin: 'HOW TO WIN:',
    winText: 'Enter your name and E-Mail to become winner of the day and receive the prize!',
    startBtn: 'Start!',
    gameFinished: 'Game Finished!',
    wellDone: 'Well done!',
    yourScore: 'YOUR SCORE',
    transformedCabinets: 'TRANSFORMED CABINETS',
    yourRank: 'YOUR RANK',
    keepHunting: 'Keep hunting!',
    enterName: 'Your Name',
    enterEmail: 'E-Mail (optional)',
    saveScore: 'Save Score',
    timeRemaining: 'Time',
    missed: 'Missed',
    autoAim: 'Auto-Aim',
  },

  // Automation Drop Game
  automationDrop: {
    title: 'AUTOMATION DROP',
    subtitle: '— POWERED BY UKONN-X —',
    mission: 'Mission: Zero Cabinet! Turn Cabinets into Decentral Solutions!',
    howToPlay: 'HOW TO PLAY:',
    inst1: 'Tag Decentral Parts to score Points',
    inst1Sub: 'Drag parts into the slots',
    inst2: '5 missed Parts = Game Over',
    inst3: 'Tag Old Cabinets for Recycling',
    inst3Sub: 'Old cabinets go to trash',
    howToWin: 'HOW TO WIN:',
    winText: 'Enter your name and E-Mail to become winner of the day and receive the prize!',
    startBtn: 'Start!',
    highscoreBtn: 'Highscore',
    partsLabel: 'Parts:',
    missesLabel: 'Errors:',
    trashLabel: '🗑️ Recycling',
    gameFinished: 'Game Finished!',
    won: 'YOU WON!',
    wellDone: 'Well done!',
    finalScore: 'FINAL SCORE',
    yourRank: 'YOUR RANK',
    saveScore: 'Keep hunting!',
    toMenu: 'Main Menu',
    tooSlow: 'Too slow!',
    wrong: 'Wrong!',
    oops: 'Oops!',
    levelUp: 'LEVEL UP! ⚡',
    retroMsg: 'The 80s want their stuff back!',
    nope: 'NOPE!',
  },
};
